import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../api/client.js';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      /**
       * The board is kept fresh by the realtime stream, not by polling. A
       * refetch on every window focus would also risk overwriting an in-flight
       * optimistic drag, so it stays off.
       */
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Never retry a refusal — it will be refused again. 401 has already
        // redirected to login by the time we get here.
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
